const read_outcome_key = (value = '') => {
    return `${value || ''}`.trim().toLowerCase().replace(/[\s-]+/g, '_');
};

// Keeps the matched account and Paid transition in one board request.
export const read_sass_outcome_request_payload = (outcomePayload = {}, accountData = {}) => {
    const outcome = read_outcome_key(outcomePayload.outcome);

    if (outcome === 'lost') {
        const lostPayload = { ...outcomePayload };

        delete lostPayload.accountUsername;

        return lostPayload;
    }

    if (outcome !== 'paid') {
        return outcomePayload;
    }

    return {
        ...outcomePayload,
        accountData
    };
};

// Paid carries its verified account atomically; Lost intentionally bypasses account saving.
export const read_sass_outcome_submits_directly = (outcome = '') => {
    return ['paid', 'lost'].includes(read_outcome_key(outcome));
};
